import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { body2, body2Bold } from '@westwing/ui-kit/typography';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import useBellaTranslator from '../../hooks/useTranslator';
import HybridLink from '../Generic/Links/HybridLink';
import { phoneNumberToLink } from '../../../common/helpers/phoneNumber';
import useConfig from '../../hooks/useConfig';

export const AccordionContentWrapper = styled.div`
    margin: 15px 0 35px;
    display: flex;
    flex-direction: column;
    ${forDesktop`
        margin-top: 23px;
    `}
`;

const SubTitle = styled.div`
    ${body2Bold}
    color: ${({ theme }) => theme.colors.charcoal100};
`;

const Telephone = styled(HybridLink)`
    ${body2}
    margin-top: 5px;
    color: ${({ theme }) => theme.colors.charcoal100};
`;

const ContactForm = styled(Telephone)`
    text-decoration: underline;
    margin-bottom: 32px;
    ${forDesktop`
        margin-bottom: 22px;
    `}
`;

const FAQ = styled(HybridLink)`
    ${body2Bold}
    color: ${({ theme }) => theme.colors.charcoal100};
`;

const ContactAndFAQ: FC = (): ReactElement => {
    const t = useBellaTranslator();
    const config = useConfig();

    const phoneNumber = t('Phone Number');

    return (
        <AccordionContentWrapper>
            <SubTitle>{t('Footer_Contact')}</SubTitle>
            <Telephone to={phoneNumberToLink(phoneNumber)}>{phoneNumber}</Telephone>
            <ContactForm to={config.links.helpCenterContactUrl}>{t('Contact Form')}</ContactForm>
            <FAQ to={config.links.helpCenterUrl}>{t('Footer_FAQ')}</FAQ>
        </AccordionContentWrapper>
    );
};

export default ContactAndFAQ;
